"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_WELLS_TO_MAP = void 0;
exports.MAX_WELLS_TO_MAP = 2000;
//# sourceMappingURL=Well.js.map